import mockProduct from './products/product';

export default {
  product: mockProduct,
  option: `1/8 oz`,
  quantity: 1,
  price: 20.0,
  basePrice: 20,
  getReceiptItem: () => undefined,
};
